import { apiSlice } from "../../apiSlice";

export const shipTrackApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    consultarShipTrack: builder.mutation({
      query: ({ doctrans, captchat }) => ({
        url: "Operacix/Shtrackx",
        method: "POST",
        body: {
          doctrans,
          captchat: captchat,
        },
      }),
    }),
  }),
});

export const { useConsultarShipTrackMutation } = shipTrackApi;
